<template>
  <div class="user-licenses-table-cell">
    <span
      v-for="license in licenses"
      :key="license.id"
      :class="[
        'license',
        license.role
          ? license.role
              .split(' ')
              .map((word) => word.toLowerCase())
              .join('-')
          : '',
      ]"
    >
      <span>{{ license.role }}</span>
      <span v-if="license.removeDate" :style="{ fontSize: '10px' }">
        (removes on {{ dateFilter(license.removeDate, 'MM/dd/yyyy') }})
      </span>
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { dateFilter } from '@filters/date';

import type { User, License } from '@models';

/**
 * `TableCellUserLicenses` component properties.
 */
export interface Props {
  item: User & { licenses: License[] };
}

const props = defineProps<Props>();

const licenses = computed(() => props.item.licenses);
</script>

<script lang="ts">
declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellUserLicenses: ComponentWithProps<Props>;
  }
}

export default { name: 'TableCellUserLicenses' };
</script>

<style lang="scss" scoped>
.user-licenses-table-cell {
  font-size: 12px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 4px;

  .license {
    display: inline-block;
    padding: 2px 8px;
    text-align: center;
    border-radius: 10px;

    &.student {
      color: $role-pill-student-color;
      background-color: $role-pill-student-background;
    }

    &.instructor {
      color: $role-pill-instructor-color;
      background-color: $role-pill-instructor-background;
    }

    &.institution-admin {
      color: $role-pill-institution-admin-color;
      background-color: $role-pill-institution-admin-background;
    }
  }
}
</style>
